module.exports = __webpack_public_path__ + "img/PayPal.0e160d14.jpeg";